import { Link } from 'react-router-dom';

const projects = [
    {
        id: 1,
        title: "Startup on Data Analysis Using Python",
        description: (
            <>Beginner tutorial on data analysis using python.</>
        ),
        url: "#"
    },
    {
        id: 2,
        title: "Algorithm pratice",
        description: (
            <>Practice routine of algorithm.</>
        ),
        url: "/Tips/Algorise"
    },
    {
        id: 3,
        title: "Python Basics",
        description: (
            <>Data structure in Python.</>
        ),
        url: "/Tips/Pydamental"
    },
    {
        id: 4,
        title: "Machine Learning Models in Python",
        description: (
            <>
                A systematic overview of machine learning models in Python. <br />
                Reference book: <a href="https://hastie.su.domains/ElemStatLearn/" target="_blank" rel="noopener noreferrer" className="underline hover:text-gray-800">"The Elements of Statistical Learning"</a>.
            </>
        ),
        url: "/Tips/MLModels"
    }
];

const includeIds = [4];
const filterprojects = projects.filter(item => includeIds.includes(item.id));

const Tips = () => {
    return (
        <main className="flex-grow flex flex-col justify-center items-center p-6 overflow-auto">
            <div className="text-center w-full max-w-5xl mx-auto">
                <div className="text-left w-full mt-8">
                    {filterprojects.map((project) => (
                        <div key={project.id} className="mb-16">
                            <Link to={project.url} className="cursor-pointer hover:opacity-80 transition-opacity inline-block">
                                <h2 className="text-xl md:text-2xl font-bold mb-2 relative group">
                                    {project.title}
                                    <span className="block h-[1px] bg-gradient-to-r from-black to-gray-400 mt-1 w-[125%] group-hover:w-full transition-all duration-500"></span>
                                </h2>
                            </Link>
                            <div className="pl-8 text-left text-gray-700 text-sm md:text-base [&_a]:no-underline [&_a]:text-blue-700 [&_a:hover]:text-blue-700 [&_a:hover]:opacity-80 ">
                                {project.description}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </main>
    );
};

export default Tips;